import React from 'react';
import SimpleBar from 'simplebar-react';
import { useMediaQuery } from 'react-responsive';
import * as S from './Styled';

const ScrollWrapper = ({ children, maxHeight = 435, ...rest }) => {
  const isMob = useMediaQuery({ query: '(max-width: 767px)' });

  return isMob ? (
    children
  ) : (
    <S.Wrapper>
      <SimpleBar style={{ maxHeight }} {...rest}>
        {children}
      </SimpleBar>
    </S.Wrapper>
  );
};

export default ScrollWrapper;
